import { gql } from '@apollo/client';

export const SET_SAVED_JOB_NOTES = gql`
  mutation SetSavedJobNotes($input: SetSavedJobNotesInput!, $locale: Locale) {
    setSavedJobNotes(input: $input) {
      ... on SetSavedJobNotesSuccess {
        id
      }
      ... on SetSavedJobNotesFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
